import type { IOfficeConsent } from '../types/OfficeConsent';
import type { IOfficeConsentApi } from '../types/OfficeConsent.api';

/**
 * Transform API response (snake_case) to Domain type (camelCase)
 */
function toOfficeConsent(apiResponse: IOfficeConsentApi): IOfficeConsent {
  return {
    code: apiResponse.code,
    officeId: apiResponse.office_id,
    isConsented: apiResponse.is_consented,
  };
}

export const OfficeConsentAdapter = {
  toOfficeConsent,
};
